import React, { useContext, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

// Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';

// Pages
import * as PAGES from './pages';
import { ApiContext } from './context/api/apiContext';

const App = () => {
	const { jsonData, setJsonData } = useContext(ApiContext);

	useEffect(() => {
		(async () => {
			try {
			// 	const rawResponse = await fetch('../data/jsonData.json', {
			// 	method: 'GET',
			// 	headers: {
			// 		'Accept': 'application/json',
			// 		'Content-Type': 'application/json',
			// 		'secret-key': "$2b$10$N99BZwsYN07CNutWAUmedumgrTY0Jl5F5Ox.MUon3ZpHihRsBvSsm"
			// 	},
			// });
			const rawResponse = await fetch('../data/jsonData.json');

			const content = await rawResponse.json();

			setJsonData(content);
	
			} catch(err) {
				console.log(err);
			}
		
		})();
	}, [])

	return (
		jsonData && jsonData.pages ? (
			<div className="wrapper">
				<Header />
				<div className="base">
					<Switch>
						<Route path="/" component={PAGES.Home} exact />
						<Route component={PAGES.HowItWorks} path="/how-it-works" />
						<Route component={PAGES.Help} path="/help" />
						<Route component={PAGES.Streams} path="/streams" />
						<Route component={PAGES.Producers} path="/producers" />
						<Route component={PAGES.Login} path="/login" />
						<Route component={PAGES.Join} path="/join" />
						<Route component={PAGES.RestorePassword} path="/restore-password" />
						<PrivateRoute component={PAGES.MyStreams} path="/my-streams" />
						<PrivateRoute component={PAGES.EditStream} path="/edit-stream/:id" />
						<PrivateRoute component={PAGES.CreateStream} path="/create-stream" />
						<PrivateRoute component={PAGES.NotFound} path="*" />
					</Switch>
				</div>
				<Footer />
			</div>
		) : null
	)
};

export default App;